import { utilities } from "@/shared/utils/utility";

export type ValidationRule = "" | "numericOnly" | "standard" | "lineBreakStandard" | "halfWidthAlnumSymbols" | "halfWidthAlnum" | "lineBreakMultipleSymbols" | "numericAndHyphenOnly" | "deleteOver4Bytes";

export const useInputValidation = (rule: ValidationRule) => {
  const { 
    deleteCharacterExceptDecimal,
    convertFullWidthSymbolToHalfWidth,
    convertFullWidthSymbolToHalfWidthKeepFullWidthNumber,
    deleteLimitedCharacter,
    deleteLimitedCharacterWithoutLineBreak,
    deleteCharacterExceptAlphanumericAndSymbols,
    deleteCharacterExceptAlphanumeric,
    deleteCharacterExceptDecimalHyphen,
    deleteCharacterOver4Bytes,
  } = utilities();

  /**
   * 入力値を検証・フォーマットする
   * @param value 入力値
   * @param isComposing IME入力中かどうか
   * @returns フォーマット済みの値
   */
  const validate = (value: string, isComposing: boolean = false): string => {
    // IME入力中は全ルールで変換しない
    if (isComposing) {
      return value;
    }

    if (rule === "numericOnly") {
      // 数字のみを許可
      return deleteCharacterExceptDecimal(value);
    } 

    else if (rule === "numericAndHyphenOnly") {
      // 数字とハイフンのみを許可
      return deleteCharacterExceptDecimalHyphen(value);
    }

    else if (rule === "halfWidthAlnumSymbols") {
        // 半角英数記号のみを許可
      return deleteCharacterExceptAlphanumericAndSymbols(value);
    }

    else if (rule === "halfWidthAlnum"){
        // 半角英数文字のみを許可
        return deleteCharacterExceptAlphanumeric(value);
    }

    else if (rule === "standard") {
        // "standard": 英数字、ひらがな、カタカナ、漢字、スペース、記号の一部のみ許可
        value = convertFullWidthSymbolToHalfWidth(value);
        value = deleteLimitedCharacter(value);
        return value;
    }
    else if (rule === "lineBreakStandard") {
        // "lineBreakStandard": 英数字、ひらがな、カタカナ、漢字、スペース、半角記号、ｶﾅ、全角「、。「」１２３」
        value = convertFullWidthSymbolToHalfWidthKeepFullWidthNumber(value);
        value = deleteLimitedCharacterWithoutLineBreak(value);
        return value;
    }
    else if (rule === "deleteOver4Bytes") {
        // "deleteOver4Bytes": 4バイト文字以上を削除
        return deleteCharacterOver4Bytes(value);
    }
    else {
      // ルールなし: 全ての文字を許可
      return value;
    }
  };

  return { validate };
};
